module.exports = __webpack_public_path__ + "static/media/Registration_Community.eda11c8c.gif";